var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"navigate-back",on:{"click":_vm.navigateBackOne}},[_vm._v(" "+_vm._s(_vm.label || _vm.t)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }